export default {
  "Loop as a GIF": "Loop sebagai GIF",
  "without sound": "tanpa suara",
  "Final output duration": "Durasi output akhir",
};
